/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ConnectInputs */

const en_footer_connect = /** @type {(inputs: Footer_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`connect`)
};

const ar_footer_connect = /** @type {(inputs: Footer_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل`)
};

const bn_footer_connect = /** @type {(inputs: Footer_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যোগাযোগ`)
};

const de_footer_connect = /** @type {(inputs: Footer_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verbinden`)
};

const es_footer_connect = /** @type {(inputs: Footer_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conectar`)
};

const fr_footer_connect = /** @type {(inputs: Footer_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`se connecter`)
};

const pt_footer_connect = /** @type {(inputs: Footer_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conectar`)
};

const zh_footer_connect = /** @type {(inputs: Footer_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接`)
};

const tr_footer_connect = /** @type {(inputs: Footer_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bağlan`)
};

const ru_footer_connect = /** @type {(inputs: Footer_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связаться`)
};

const pl_footer_connect = /** @type {(inputs: Footer_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`połącz`)
};

/**
* | output |
* | --- |
* | "connect" |
*
* @param {Footer_ConnectInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const footer_connect = /** @type {((inputs?: Footer_ConnectInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ConnectInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_footer_connect(inputs)
	if (locale === "bn") return bn_footer_connect(inputs)
	if (locale === "de") return de_footer_connect(inputs)
	if (locale === "es") return es_footer_connect(inputs)
	if (locale === "fr") return fr_footer_connect(inputs)
	if (locale === "pt") return pt_footer_connect(inputs)
	if (locale === "zh") return zh_footer_connect(inputs)
	if (locale === "tr") return tr_footer_connect(inputs)
	if (locale === "ru") return ru_footer_connect(inputs)
	if (locale === "pl") return pl_footer_connect(inputs)
	return en_footer_connect(inputs)
});